import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import CounterpartiesGroupsApi from '@/services/apiServiceModules/counterpartiesGroupsApi.js'

const counterpartiesGroupsApi = new CounterpartiesGroupsApi()

export default class CounterpartiesGroupsDt extends DataTransferModule {
    constructor() {
        super(ModulesMap.COUNTERPARTIES_GROUPS, counterpartiesGroupsApi, {
            useCache: true,
        })
    }
}
